export default __webpack_public_path__ + "static/media/decline.c81273a6.svg";